<template>
  <div class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="fw-bold mb-0">Loading...</p>
  </div>
</template>

<script>
export default {
  name: 'loading-state'
}
</script>

<style>

</style>